import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { open: true }
const _hoisted_3 = ["disabled"]




export default /*#__PURE__*/_defineComponent({
  props: {
    confirm: null,
    cancel: null
  },
  emits: ["confirm", "cancel", "exit"],
  setup(__props: any, { emit }: { emit: ({
    (e: "confirm"): void;
    (e: "cancel"): void;
    (e: "exit"): void;
}), expose: any, slots: any, attrs: any }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("dialog", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", {
        class: _normalizeClass(["modal__footer", {
                    'justify-center': __props.cancel === null || __props.confirm === null,
                }])
      }, [
        (__props.cancel !== null)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(__props.cancel?.class || 'btn btn-light'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
            }, _toDisplayString(__props.cancel?.text || "Annuler"), 3))
          : _createCommentVNode("", true),
        (__props.confirm !== null)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              disabled: __props.confirm?.disabled === true,
              class: _normalizeClass(__props.confirm?.class || 'btn btn-primary'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
            }, _toDisplayString(__props.confirm?.text || "Confirmer"), 11, _hoisted_3))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", {
      class: "modal-background",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('exit')))
    })
  ]))
}
}

})